import { render } from "./ResetAllItems.vue?vue&type=template&id=4a4e22b6&scoped=true"
import script from "./ResetAllItems.vue?vue&type=script&lang=js"
export * from "./ResetAllItems.vue?vue&type=script&lang=js"

import "./ResetAllItems.vue?vue&type=style&index=0&id=4a4e22b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4e22b6"]])

export default __exports__